export enum BureauType {
  BUREAU = 'BUREAU',
  SOLO_PRACTICE = 'SOLO_PRACTICE',
}
